import { defineComponent as _defineComponent } from 'vue'
import OzDropdownButton, { OzDropdownButtonSizePreset } from '@@/library/v4/components/OzDropdownButton.vue'
import OzOverlay from '@@/library/v4/components/OzOverlay.vue'
import { useSurfaceStore } from '@@/pinia/surface'
import { useWindowSizeStore } from '@@/pinia/window_size'
import SurfaceDropdown from '@@/vuecomponents/SurfaceDropdown.vue'
import { shiftUpWhenOverflow, useFloating } from '@@/vuecomposables/floating'
import { offset } from '@floating-ui/vue'
import type { OzMenuRowsRow } from 'library/v4/components/OzMenuRows.vue'
import { storeToRefs } from 'pinia'
import type { ComponentPublicInstance } from 'vue'
import { computed, ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'SurfaceRowDropdown',
  props: {
    fieldLabel: null,
    fieldLabelDescription: null,
    dropdownLabel: null,
    buttonText: null,
    rows: null,
    buttonTestId: null,
    dropdownTestId: null,
    darkMode: { type: Boolean }
  },
  emits: ['select-row'],
  setup(__props: any, { emit }) {



const { dir } = storeToRefs(useSurfaceStore())
const { windowHeight } = storeToRefs(useWindowSizeStore())

const isDropdownOpen = ref(false)

const onRowSelect = (event, payload) => {
  isDropdownOpen.value = false
  emit('select-row', event, payload)
}

/** Floating UI */
// The floating dropdown is initially positioned relative to the dropdown button,
// then as the viewport becomes smaller, the dropdown may be taller than the viewport and overflow.
// Once it starts to overflow, it is no longer anchored to anything.
// It will just be positioned at y = 0, where it still respects the margin of 12px.

const button = ref<InstanceType<typeof OzDropdownButton> | null>(null)
const popover = ref<ComponentPublicInstance<HTMLElement> | null>(null)
const reference = computed(() => button.value?.$el as any)
const floating = computed(() => popover.value?.$el as any)

const MAX_POPOVER_HEIGHT = computed(() => windowHeight.value - 12 * 2)
const { floatingStyles } = useFloating(reference, floating, {
  // since we already set a margin of 12px, and we want an offset of 4px, we reduce the offset by 8px
  middleware: [offset(-8), shiftUpWhenOverflow()],
  placement: 'bottom-end',
})

return { __sfc: true,dir, windowHeight, isDropdownOpen, emit, onRowSelect, button, popover, reference, floating, MAX_POPOVER_HEIGHT, floatingStyles, OzDropdownButton, OzDropdownButtonSizePreset, OzOverlay, SurfaceDropdown }
}

})